import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ed19a988"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "s1-track"
};
const _hoisted_2 = {
  class: "mobile-wrapper"
};
const _hoisted_3 = {
  class: "today-box",
  id: "today-box"
};
const _hoisted_4 = {
  class: "date-title"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ion ion-ios-add"
}, null, -1));

const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  key: 0,
  class: "upcoming-events"
};
const _hoisted_8 = {
  class: "container"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "包裹轨迹", -1));

const _hoisted_10 = {
  class: "events-wrapper"
};
const _hoisted_11 = {
  class: "event active"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ion ion-ios-radio-button-on icon-in-active-mode"
}, null, -1));

const _hoisted_13 = {
  class: "event__point"
};
const _hoisted_14 = {
  class: "event__description"
};
const _hoisted_15 = {
  class: "event__content"
};
const _hoisted_16 = {
  class: "event__left"
};
const _hoisted_17 = {
  class: "event__point"
};
const _hoisted_18 = {
  class: "event__description"
};
const _hoisted_19 = {
  class: "event__right"
};
const _hoisted_20 = {
  class: "event__location",
  style: {
    "text-align": "right"
  }
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "colon",
  style: {
    "margin-right": "5px"
  }
}, ":", -1));

const _hoisted_22 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_My_loading = _resolveComponent("My-loading");

  const _component_el_empty = _resolveComponent("el-empty");

  const _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.centerDialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.centerDialogVisible = $event),
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    showClose: false,
    width: "800px",
    center: ""
  }, {
    header: _withCtx(({}) => []),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("section", _hoisted_3, [_createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translateTitle("最新包裹轨迹")), 1), _createElementVNode("div", {
      class: "plus-icon",
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.closeDialog && _ctx.closeDialog(...args))
    }, _hoisted_6)]), _ctx.state === 1 ? (_openBlock(), _createElementBlock("section", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: item,
        class: "events-box"
      }, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.translateTitle("运单号")) + "：" + _toDisplayString(index), 1), _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.translateTitle("最新轨迹")) + "：" + _toDisplayString(_ctx.type === "zh" ? item[item.length - 1].zhDescription : item[item.length - 1].description), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (sonItem, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: sonItem,
          class: "event"
        }, [_createElementVNode("i", {
          class: _normalizeClass(index === 0 ? 'ion ion-ios-flame hot' : index === 1 ? 'ion ion-ios-flame done' : 'ion ion-ios-flame-outline upcoming')
        }, null, 2), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("h4", _hoisted_17, _toDisplayString(sonItem.eventTimeStr) + " " + _toDisplayString("  GMT+" + sonItem.timeZone), 1), _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.type === "zh" ? sonItem.zhDescription : sonItem.description), 1)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("p", _hoisted_20, [_createTextVNode(_toDisplayString(_ctx.translateTitle("操作地点")) + " ", 1), _hoisted_21, _createTextVNode(" " + _toDisplayString(sonItem.location), 1)])])])]);
      }), 128))]);
    }), 128))])])])) : _ctx.state === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_My_loading)])) : _ctx.state === 2 ? (_openBlock(), _createBlock(_component_el_empty, {
      key: 2,
      description: "该运单号暂无物流动态",
      style: {
        "height": "596px"
      }
    })) : (_openBlock(), _createBlock(_component_el_empty, {
      key: 3,
      description: "系统错误,请稍后重试",
      style: {
        "height": "596px"
      }
    }))])]),
    _: 1
  }, 8, ["modelValue"])]);
}